import { logger } from '#app/services/logger.js';
import { type AnalyticsContextProps } from './types.js';
import { createContext } from 'react';

const log = logger.child({
  namespace: 'AnalyticsContext',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Argument = any;

const fallbackAnalytics = {
  identify: (...args: Argument[]) => {
    log.warn({ args }, '"identify" used without Analytics');
  },
  instance: null,
  page: (...args: Argument[]) => {
    log.warn({ args }, '"page" used without Analytics');
  },
  reset: (...args: Argument[]) => {
    log.warn({ args }, '"reset" used without Analytics');
  },
  track: (...args: Argument[]) => {
    log.warn({ args }, '"track" used without Analytics');
  },
};

export const AnalyticsContext = createContext<AnalyticsContextProps>({
  ...fallbackAnalytics,
  campaign: null,
  userId: null,
});
